export var isConstantSourceNode = function isConstantSourceNode(audioNode) {
  return 'offset' in audioNode;
};